import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import PageBanner from '../../components/Banner/PageBanner';
import JobsList from '../Dashboard/LocumJobs/JobsList/JobsList';
import JobInfo from '../Dashboard/LocumJobs/JobInfo/JobInfo';
import Nav from '../../layout/UsersDashboard/sideNav/Nav';
import MobileNav from '../../layout/UsersDashboard/sideNav/MobileNav';
import DashboardHeader from '../../layout/UsersDashboard/header/DashboardHeader';
import useGetGuestJobs from '../../hooks/guest/useGetGuestJobs';
import BackToJobListButton from '../../components/BackToJobListButton/BackToJobListButton';
import Page from '../../components/Page/Page';
import { InternalNavLink } from '../../components/Link/Link';
import { ACCOUNT, SIGNUP } from '../../routes/routeConstants';

const ViewOnlyJobs = () => {
  const [showMobileInfo, setShowMobileInfo] = useState<boolean>(false);
  const [open, setOpen] = useState(false);

  const { getGuestJobs } = useGetGuestJobs();

  useEffect(() => {
    getGuestJobs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Locumspace | Guest">
      <Container>
        <Nav guest />
        <MobileNav
          guest
          open={open}
          toggleNav={() => {
            setOpen(!open);
          }}
        />
        <Section>
          <DashboardHeader
            guest
            open={open}
            toggleNav={() => {
              setOpen(!open);
            }}
          />
          {/* {splitLocation[3] === 'settings' && <SettingsHeader />} */}
          <MainContent>
            <Shell>
              <Container2>
                <PageBanner
                  label="Guest Access"
                  description="Please sign in to explore more jobs"
                  className={``}
                />
                <BackToJobListButton
                  showMobileInfo={showMobileInfo}
                  setShowMobileInfo={setShowMobileInfo}
                />
                <JobViewArea>
                  <JobsList
                    showMobileInfo={showMobileInfo}
                    setShowMobileInfo={setShowMobileInfo}
                    loading={false}
                    guest
                  />
                  <JobInfo showMobileInfo={showMobileInfo} guest />
                </JobViewArea>
              </Container2>
            </Shell>
          </MainContent>
          <Div>
            {' '}
            <See to={`/${ACCOUNT}/${SIGNUP}`}>See more</See>
          </Div>
        </Section>
      </Container>
    </Page>
  );
};

export default ViewOnlyJobs;

const Container = styled.div`
  display: grid;
  grid-template-columns: 294px 1fr;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background-color: #f2f8fd;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    width: 100vw;
  }
`;

const Section = styled.section`
  width: 100%;
  height: fit-content;

  & > * {
    padding-left: 54px;
    padding-right: 54px;
  }

  @media (max-width: 884px) {
    & > * {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`;

const MainContent = styled.main`
  height: 100%;
  width: 100%;
`;

const Shell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Container2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  background-color: ${({ theme }) => theme.palette.backgroundColor};
  padding: 2rem;
  border-radius: 0.75rem;
  height: 100%;

  @media (max-width: 540px) {
    /* border: 1px solid yellow; */
    padding: 20px;
    border-radius: 0;
    // background-color: white;
    background-color: ${({ theme }) => theme.palette.backgroundColor};
    margin-left: -20px;
    margin-right: -20px;
  }
`;

const JobViewArea = styled.div`
  display: grid;
  grid-template-columns: 316px 1fr;
  gap: 32px;
  height: fit-content;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;

const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 2rem;
`;

const See = styled(InternalNavLink)`
  color: ${({ theme }) => theme.palette.mainBlue};
  text-decoration: underline;
`;
